import { createAction } from "redux-actions";

const ActionTypes = {
    SET_SELECTED_DOMAIN: "SET_SELECTED_DOMAIN",
    GET_GSC_REPORT_DATA: "GET_GSC_REPORT_DATA",
    SET_GSC_REPORT_DATA: "SET_GSC_REPORT_DATA",
    DOWNLOAD_GSC_REPORT_DATA: "DOWNLOAD_GSC_REPORT_DATA",
    SET_DOWNLOAD_GSC_REPORT_DATA: "SET_DOWNLOAD_GSC_REPORT_DATA",
    GET_GSC_SAVED_VIEWS_LIST: "GET_GSC_SAVED_VIEWS_LIST",
    SET_GSC_SAVED_VIEWS_LIST: "SET_GSC_SAVED_VIEWS_LIST",
    CREATE_GSC_SAVED_VIEW: "CREATE_GSC_SAVED_VIEW",
    SET_CREATE_GSC_SAVED_VIEW: "SET_CREATE_GSC_SAVED_VIEW",
    UPDATE_GSC_SAVED_VIEW: "UPDATE_GSC_SAVED_VIEW",
    SET_UPDATE_GSC_SAVED_VIEW: "SET_UPDATE_GSC_SAVED_VIEW",
    DELETE_GSC_SAVED_VIEW: "DELETE_GSC_SAVED_VIEW",
    SET_DELETE_GSC_SAVED_VIEW: "SET_DELETE_GSC_SAVED_VIEW",
    GET_GSC_TENANT_DETAILS: "GET_GSC_TENANT_DETAILS",
    SET_GSC_TENANT_DETAILS: "SET_GSC_TENANT_DETAILS",
};
export default ActionTypes;

// GETTERS / API CALL ACTIONS
export const setSelectedDomain = createAction(ActionTypes.SET_SELECTED_DOMAIN);
export const getGSCReportData = createAction(ActionTypes.GET_GSC_REPORT_DATA);
export const setGSCReportData = createAction(ActionTypes.SET_GSC_REPORT_DATA);
export const downloadGSCReportData = createAction(ActionTypes.DOWNLOAD_GSC_REPORT_DATA);
export const setDownloadGSCReportData = createAction(ActionTypes.SET_DOWNLOAD_GSC_REPORT_DATA);
export const getGSCSavedViewsList = createAction(ActionTypes.GET_GSC_SAVED_VIEWS_LIST);
export const setGSCSavedViewsList = createAction(ActionTypes.SET_GSC_SAVED_VIEWS_LIST);
export const createGSCSavedView = createAction(ActionTypes.CREATE_GSC_SAVED_VIEW);
export const setCreateGSCSavedView = createAction(ActionTypes.SET_CREATE_GSC_SAVED_VIEW);
export const updateGSCSavedView = createAction(ActionTypes.UPDATE_GSC_SAVED_VIEW);
export const setUpdateGSCSavedView = createAction(ActionTypes.SET_UPDATE_GSC_SAVED_VIEW);
export const deleteGSCSavedView = createAction(ActionTypes.DELETE_GSC_SAVED_VIEW);
export const setDeleteGSCSavedView = createAction(ActionTypes.SET_DELETE_GSC_SAVED_VIEW);
export const getGSCTenantDetails = createAction(ActionTypes.GET_GSC_TENANT_DETAILS);
export const setGSCTenantDetails = createAction(ActionTypes.SET_GSC_TENANT_DETAILS);
